'use strict';exports.__esModule = true;exports.default = getLoadType;function getLoadType() {
  var type = null;
  if (global.performance) {var _global$performance$n =
    global.performance.navigation;_global$performance$n = _global$performance$n === undefined ? {} : _global$performance$n;var id = _global$performance$n.type;
    type = id === 1 ? 'reload' : 'direct';
  } else if (document && !document.referrer) {
    type = 'direct';
  }

  return type;
}module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/getLoadType.js
// module id = 1292
// module chunks = 0